import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';

// Models
import { EditNarrativePayload } from 'app/modules/narratives/requests';
import { Narrative } from 'app/modules/narratives/models';

// APIs
import {
  deleteNarrativeApi,
  editNarrativeApi,
} from 'app/modules/narratives/api';

// Utils
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';

const NARRATIVES_NAME = 'narratives';

export const editNarrativeThunk = u21CreateAsyncThunk<
  EditNarrativePayload,
  Narrative
>(`${NARRATIVES_NAME}/EDIT_NARRATIVE`, async (payload, { dispatch }) => {
  try {
    const response = await editNarrativeApi(payload);
    dispatch(sendSuccessToast(`Narrative successfully edited`));
    return response;
  } catch (e) {
    dispatch(sendErrorToast('Unable to edit narrative. Please try again'));
    throw e;
  }
});

export const deleteNarrativeThunk = u21CreateAsyncThunk<number, Narrative>(
  `${NARRATIVES_NAME}/DELETE_NARRATIVE`,
  async (id, { dispatch }) => {
    try {
      const response = await deleteNarrativeApi(id.toString());
      dispatch(sendSuccessToast(`Narrative successfully deleted`));
      return response;
    } catch (e) {
      dispatch(sendErrorToast('Unable to delete narrative. Please try again'));
      throw e;
    }
  },
);
